<template>
  <!-- Main sidebar -->
  <div class="sidebar sidebar-dark sidebar-main sidebar-expand-md">
    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
      <router-link
        to="#"
        class="sidebar-mobile-main-toggle"
      >
        <i class="icon-arrow-left8" />
      </router-link>
      {{ $t("Goship") }}
      <router-link
        to="#"
        class="sidebar-mobile-expand"
      >
        <i class="icon-screen-full" />
        <i class="icon-screen-normal" />
      </router-link>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- Sidebar content -->
    <div class="sidebar-content">
      <!-- Main navigation -->
      <div class="card card-sidebar-mobile" data-test="menus-nav-sidebar">
        <ul
          class="nav nav-sidebar"
          data-nav-type="accordion"
        >
          <!-- Main -->
          <li
            class="nav-item"
            v-if="menuValid('home.home')"
          >
            <router-link
              :to="{name: 't.a.home'}"
              class="nav-link"
              data-test="menus-item-home"
            >
              <i class="fas fa-home-lg" /><span>{{ $t("Home") }}</span>
            </router-link>
          </li>

          <li
            class="nav-item"
            v-if="menuValid('dashboard.dashboard')"
          >
            <router-link
              :to="{name: 't.a.dashboard'}"
              class="nav-link"
              data-test="menus-item-dashboard"
            >
              <i class="fas fa-gauge-high " /><span>{{ $t("Dashboard") }}</span>
            </router-link>
          </li>

          <li
            class="nav-item nav-item-submenu"
            v-show="menuValid('order.order')"
            data-test="menus-item-order"
          >
            <span class="nav-link cursor-pointer">
              <i class="fas fa-shopping-cart" /><span>{{ $t("Orders") }}</span>
            </span>
            <ul class="nav nav-group-sub sub-menu">
              <li
                class="nav-item"
                v-if="menuValid('order.order')"
              >
                <router-link
                  :to="{name: 't.a.order.index'}"
                  class="nav-link"
                  data-test="sub-menus-item-order"
                >
                  <i class="fas fa-shopping-cart" /><span>{{ $t("Orders") }}</span>
                </router-link>
              </li>
              <li
                class="nav-item"
                v-if="menuValid('order.order_draft')"
              >
                <router-link
                  :to="{name: 't.a.ordersdrafts.index'}"
                  class="nav-link"
                  data-test="sub-menus-item-order-draft"
                >
                  <i class="fa-solid fa-file-pen" />{{ $t("Order Drafts") }}
                </router-link>
              </li>
              <li
                class="nav-item"
                v-if="menuValid('order.return')"
              >
                <router-link
                  :to="{name: 't.a.return-order'}"
                  class="nav-link"
                  data-test="sub-menus-item-return-order"
                >
                  <i class="fa-solid fa-square-fragile" />{{ $t("Return Orders") }}
                </router-link>
              </li>
            </ul>
          </li>

          <li
            class="nav-item"
            v-if="menuValid('social_commerce.chat')"
            style="cursor: pointer;"
            @click="gotoGoChat()"
            data-test="menus-item-social-chat"
          >
            <div
              class="nav-link actives d-flex flex-row align-items-center"
            >
              <i class="fas fa-comments" /><span>{{ $t("_GoChatMenu.Chat") }}</span>
              <div
                v-if="gochatLoading"
                class="spinner-border spinner-border-sm text-light ml-2"
                role="status"
              >
                <span class="sr-only">{{ $t("Loading...") }}</span>
              </div>
            </div>
          </li>

          <!-- <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-shopping-cart"></i><span>{{$t("Orders")}}</span></span>
                    <ul class="nav nav-group-sub"  >
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.order.index'}" class="nav-link">{{$t("Orders")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.order.draft'}" class="nav-link">{{$t("Draft")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.order.abandoned'}" class="nav-link">{{$t("Abandoned checkouts")}}</router-link>
                        </li>
                    </ul>
                </li> -->

          <li
            class="nav-item"
            v-if="menuValid('payment.payment')"
          >
            <router-link
              :to="{name: 't.a.payments.index'}"
              class="nav-link actives"
              data-test="menus-item-payment"
            >
              <i class="fas fa-sack-dollar" /><span>{{ $t('Payment') }}</span>
            </router-link>
          </li>

          <li
            class="nav-item"
            v-if="menuValid('shipment.shipment')"
          >
            <router-link
              :to="{name: 't.a.shipment'}"
              class="nav-link actives"
              data-test="menus-item-shipment"
            >
              <i class="fas fa-shipping-fast" /><span>{{ $t("Shipment") }}</span>
            </router-link>
          </li>
          <!-- <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fas fa-shipping-fast"></i><span>{{$t("Shipment")}}</span></span>
                    <ul class="nav nav-group-sub">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.shipment'}" class="nav-link">{{$t("Shipment")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.shipment'}" class="nav-link">{{$t("Returns")}}</router-link>
                        </li>
                    </ul>
                </li> -->

          <li
            class="nav-item"
            v-if="menuValid('customer.customer')"
          >
            <router-link
              :to="{name: 't.a.customer'}"
              class="nav-link"
              data-test="menus-item-customer"
            >
              <i class="fas fa-users" /><span>{{ $t("Customer") }}</span>
            </router-link>
          </li>

          <!-- CRM -->
          <li
            class="nav-item nav-item-submenu"
            v-show="menuValid('crm.crm')"
            data-test="menus-item-crm"
          >
            <span class="nav-link cursor-pointer">
              <i class="fa-solid fa-user-headset" /><span>{{ $t("CRM") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li
                class="nav-item"
                v-if="menuValid('crm.upsell')"
              >
                <router-link
                  :to="{name: 'admin.crm.upsell'}"
                  class="nav-link"
                  data-test="sub-menus-item-upsell"
                >
                  <i class="fa-solid fa-phone-volume rotate-45-inverse" />{{ $t("_Upsell.Order Upsell") }}
                </router-link>
              </li>
              <li
                class="nav-item"
                v-if="menuValid('crm.activities')"
              >
                <router-link
                  :to="{name: 'admin.crm.activities'}"
                  class="nav-link"
                  data-test="sub-menus-item-activities"
                >
                  <i class="fa-solid fa-ballot-check" />{{ $t("Activities") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- AUTOMATION -->
          <li
            class="nav-item"
            v-if="menuValid('automation.automation')"
          >
            <router-link
              :to="{name: 't.a.automation.index'}"
              class="nav-link actives"
              data-test="menus-item-automation"
            >
              <i class="fa-solid fa-user-robot" /><span>{{ $t("Automation") }}</span>
            </router-link>
          </li>

          <!-- SALEPAGE -->
          <li
            class="nav-item nav-item-submenu"
            v-if="menuValid('salepage.salepage')"
            data-test="menus-item-salepage"
          >
            <!-- <router-link :to="{name: 't.a.salepage'}" class="nav-link"><i class="fa-regular fa-window-flip"></i><span>{{$t("Sale Page")}}</span></router-link> -->
            <span class="nav-link cursor-pointer">
              <i class="fa-regular fa-window-flip" /><span>{{ $t("Sale Page") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li class="nav-item">
                <router-link
                  :to="{name: 't.a.salepage'}"
                  class="nav-link"
                  data-test="sub-menus-item-salepage"
                >
                  <i class="fa-regular fa-window-flip" />{{ $t("Sale Page") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{name: 't.a.domain'}"
                  class="nav-link"
                  data-test="sub-menus-item-domain"
                >
                  <i class="fa-solid fa-globe" />{{ $t("Domains") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- PRODUCT -->
          <li
            class="nav-item nav-item-submenu"
            v-if="menuValid('product.product')"
            data-test="menus-item-product"
          >
            <span class="nav-link cursor-pointer">
              <i class="fa-solid fa-boxes-stacked" /><span>{{ $t("Products") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li
                class="nav-item"
                v-if="menuValid('product.product')"
              >
                <router-link
                  :to="{name: 't.a.products'}"
                  class="nav-link"
                  data-test="sub-menus-item-product"
                >
                  <i class="fas fa-box-alt" />{{ $t("Products") }}
                </router-link>
              </li>
              <!-- <li class="nav-item">
                <router-link
                  :to="{name: ''}"
                  class="nav-link"
                >
                  <i class="fa-solid fa-link" />{{ $t("Product Links") }}
                </router-link>
              </li> -->
              <li
                class="nav-item"
                v-if="menuValid('product.product_link')"
              >
                <router-link
                  :to="{name: 't.a.productlink'}"
                  class="nav-link"
                  data-test="sub-menus-item-productlink"
                >
                  <i class="fa-solid fa-link" /><span style="width: 132px;">{{ $t("Product Link") }}</span>
                  <span
                    v-if="planEndsAt >= 1 && planEndsAt <= 7"
                    style="color: #FFA726;"
                  ><i class="fa-solid fa-triangle-exclamation mr-0" /></span>
                </router-link>
              </li>
              <li
                class="nav-item"
                v-if="menuValid('product.category')"
              >
                <router-link
                  :to="{name: 't.a.category'}"
                  class="nav-link"
                  data-test="sub-menus-item-category"
                >
                  <i class="fa-solid fa-list-tree" />{{ $t("Category") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{name: 't.a.variations'}"
                  class="nav-link"
                  data-test="sub-menus-item-variations"
                >
                  <i class="fa-solid fa-shapes" />{{ $t("Variations") }}
                </router-link>
              </li>
            </ul>
          </li>
          <!-- INVENTORY -->
          <li
            class="nav-item nav-item-submenu"
            v-if="
              menuValid('inventory.inventory_list') &&
                wmsSevice == 2 &&
                ![ // ถ้ามี features ดังต่อไปนี้จะซ่อน menu
                  'feature-erp-oracle'
                ].some(slug => this.$store.state.user.feature.includes(slug))
            "
          >
            <span class="nav-link cursor-pointer nav-link-newmenu" data-test="menus-item-inventory">
              <i class="fa-solid fa-warehouse-full" /><span>{{ $t("Inventory") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li
                class="nav-item"
              >
                <router-link
                  :to="{name: 't.a.inventory-list'}"
                  class="nav-link "
                  data-test="sub-menus-item-inventory"
                >
                  <span class="cursor-pointer">
                    <i class="fa-solid fa-warehouse-full" /><span>{{ $t("Inventory Lists") }}</span>
                  </span>
                </router-link>

                <router-link
                  :to="{name: 't.a.warehouse'}"
                  class="nav-link "
                  data-test="sub-menus-item-warehouse"
                >
                  <span class="cursor-pointer">
                    <i class="fa-solid fa-warehouse" /><span>{{ $t("Warehouse") }}</span>
                  </span>
                </router-link>
                <router-link
                  :to="{name: 't.a.adjustments'}"
                  class="nav-link "
                >
                  <span class="cursor-pointer">
                    <i class="fa-solid fa-plus-minus" /><span>{{ $t("Quantity Adjustments") }}</span>
                  </span>
                </router-link>
                <router-link
                  :to="{name: 't.a.transfers'}"
                  class="nav-link "
                  data-test="sub-menus-item-transfers"
                >
                  <span class="cursor-pointer">
                    <i class="fas fa-arrows-repeat" /><span>{{ $t("_Plan.Transfers") }}</span>
                  </span>
                </router-link>
                <router-link
                  :to="{name: 't.a.stock-movement'}"
                  class="nav-link "
                  data-test="sub-menus-item-movement"
                >
                  <span class="cursor-pointer">
                    <i class="fa-solid fa-arrow-down-arrow-up" /><span>{{ $t("_Plan.Stock Movement") }}</span>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            class="nav-item"
            v-if="
              menuValid('inventory.inventory_list') &&
                wmsSevice != 2 &&
                ![ // ถ้ามี features ดังต่อไปนี้จะซ่อน menu
                  'feature-erp-oracle'
                ].some(slug => this.$store.state.user.feature.includes(slug))
            "
          >
            <router-link
              :to="{name: 't.a.inventory'}"
              class="nav-link"
              data-test="sub-menus-item-inventory"
            >
              <i class="fa-sharp fa-solid fa-warehouse-full" /><span>{{ $t("Inventory") }}</span>
            </router-link>
          </li>
          <!-- Purchases -->
          <li
            class="nav-item nav-item-submenu"
            v-if="menuValid('purchases.suppliers_list') && wmsSevice == 2"
          >
            <span class="nav-link cursor-pointer nav-link-newmenu" data-test="menus-item-purchases"><i class="fa-solid fa-cart-flatbed-boxes" />
              <span>{{ $t("Purchases") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li
                class="nav-item"
              >
                <router-link
                  :to="{name: 't.a.purchases'}"
                  class="nav-link "
                  data-test="sub-menus-item-purchases"
                >
                  {{ $t("Purchases") }}
                </router-link>
              </li>
              <li
                class="nav-item"
              >
                <router-link
                  :to="{name: 't.a.suppliers'}"
                  class="nav-link "
                  data-test="sub-menus-item-suppliers"
                >
                  {{ $t("Suppliers") }}
                </router-link>
              </li>
            </ul>
          </li>
          <!-- PROMOTION -->
          <li
            class="nav-item"
            v-if="menuValid('promotion.promotion')"
          >
            <router-link
              :to="{name: 't.a.promotions'}"
              class="nav-link"
              data-test="menus-item-promotions"
            >
              <i class="fa-solid fa-percent" /><span>{{ $t("Promotion") }}</span>
            </router-link>
          </li>

          <li
            class="nav-item nav-item-submenu"
            v-if="checkFeature('feature-fulfillment')"
          >
            <span class="nav-link cursor-pointer" data-test="menus-item-fulfillment">
              <i class="fa-solid fa-warehouse" /><span>{{ $t("Fulfillment") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li class="nav-item">
                <router-link
                  :to="{name: 'admin.fulfillment.order'}"
                  class="nav-link"
                  data-test="sub-menus-item-fulfillment-order"
                >
                  <i class="fa-solid fa-cart-flatbed" /><span>{{ $t("Orders") }}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{name: 'admin.fulfillment.products'}"
                  class="nav-link"
                  data-test="sub-menus-item-fulfillment-products"
                >
                  <i class="fas fa-box" /><span>{{ $t("Products") }}</span>
                </router-link>
              </li>
              <li
                class="nav-item"
              >
                <router-link
                  :to="{name: 'admin.fulfillment.connection'}"
                  class="nav-link"
                  data-test="sub-menus-item-fulfillment-connection"
                >
                  <i class="fa-regular fa-link" /><span>{{ $t("_Fulfillment.Connection") }}</span>
                </router-link>
              </li>
            </ul>
          </li>
          <!-- <li class="nav-item disable">
                    <router-link to="/purchase" class="nav-link"><i class="fas fa-money-bill-alt"></i><span>{{$t("Purchase")}}</span></router-link>
                </li>

                <li class="nav-item nav-item-submenu disable">
                    <router-link to="/discounts" class="nav-link"><i class="far fa-badge-percent"></i><span>{{$t("Discounts")}}</span></router-link>
                    <ul class="nav nav-group-sub">
                        <li class="nav-item">
                            <router-link to="#" class="nav-link">{{$t("Discounts")}}</router-link>
                        </li>
                    </ul>
                </li> -->



          <!--  <li class="nav-item disable">
                    <router-link to="/comments" class="nav-link"><i class="fas fa-comment"></i><span>{{$t("Comments")}}</span></router-link>
                </li> -->

          <li
            class="nav-item nav-item-submenu"
            v-if="menuValid('user.user')"
          >
            <span class="nav-link cursor-pointer" data-test="menus-item-user">
              <i class="fa-solid fa-users-gear" /><span>{{ $t("Users") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <li
                class="nav-item"
                v-if="menuValid('user.user')"
              >
                <router-link
                  :to="{name: 't.a.users'}"
                  class="nav-link"
                  data-test="sub-menus-item-user"
                >
                  <i class="fa-solid fa-users-gear" />{{ $t("Users") }}
                </router-link>
              </li>
              <li
                class="nav-item"
                v-if="menuValid('user.role_permission')"
              >
                <router-link
                  :to="{name: 't.a.roles'}"
                  class="nav-link"
                  data-test="sub-menus-item-roles"
                >
                  <i class="fa-solid fa-user-gear" />{{ $t("Roles") }}
                </router-link>
              </li>
            </ul>
            <!-- <router-link :to="{name: 't.a.users'}" class="nav-link"><i class="fas fa-user-cog"></i><span>{{$t("Users")}}</span></router-link> -->
          </li>
          <!-- <li class="nav-item ">
                    <router-link :to="{name: 't.a.roles'}" class="nav-link"><i class="fas fa-user-cog"></i><span>{{$t("Roles")}}</span></router-link>
                </li> -->

          <!-- <li class="nav-item disable">
                    <router-link to="/vendors" class="nav-link"><i class="fas fa-tasks-alt"></i><span>{{$t("Vendors")}}</span></router-link>
                </li>

                <li class="nav-item disable">
                    <router-link to="/suppliers" class="nav-link"><i class="fas fa-store"></i><span>{{$t("Suppliers")}}</span></router-link>
                </li> -->

          <!-- <li class="nav-item nav-item-submenu disable">
                    <span class="nav-link cursor-pointer"><i class="fas fa-users"></i><span>{{$t("Lead")}}</span></span>
                    <ul class="nav nav-group-sub">
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.lead.manage'}" class="nav-link">{{$t("Manage Lead")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.lead.list'}" class="nav-link">{{$t("Manage List")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.lead.dashboard'}" class="nav-link">{{$t("Dashboard")}}</router-link>
                        </li>
                    </ul>
                </li> -->

          <li
            class="nav-item"
            v-if="menuValid('user.user')"
          >
            <router-link
              :to="{name: 't.a.integrations'}"
              class="nav-link"
              data-test="menus-item-integrations"
            >
              <i class="fas fa-plug" /><span>{{ $t("Integrations") }}</span>
              <span
                v-if="marketPlaceExpire == true || $store.state.integration.voiceCallWarning == true"
                style="margin-left: 8em; color: #FFA726;"
              ><i class="fa-solid fa-triangle-exclamation mr-0" /></span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{name: 'admin.reports.index'}"
              class="nav-link actives"
              data-test="menus-item-reports"
            >
              <i class="fas fa-analytics" /><span>{{ $t("Reports") }}</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{name: 'admin.tools.index'}"
              class="nav-link"
              data-test="menus-item-tools"
            >
              <i class="fa-solid fa-screwdriver-wrench" /><span>{{ $t("Tools") }}</span>
            </router-link>
          </li>

          <!-- <li class="nav-item nav-item-submenu">
                    <span class="nav-link cursor-pointer"><i class="fal fa-comments-alt-dollar"></i><span>{{$t("Social Commerce")}}</span></span>
                    <ul class="nav nav-group-sub">
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Chat")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 't.a.live.list'}" class="nav-link">{{$t("Live")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Auto Reply")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Audience")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Broadcast")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Connect Page")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Connection")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'aaa'}" class="nav-link">{{$t("Setting Messages")}}</router-link>
                        </li>
                    </ul>
                </li> -->

          <!-- <li class="nav-item disable">
                    <router-link to="/notifications" class="nav-link"><i class="fas fa-bell-exclamation"></i><span>{{$t("Notifications")}}</span></router-link>
                </li> -->

          <li class="nav-item">
            <router-link
              :to="{
                name: 't.a.settings',
                query: {
                  page: 'info'
                }
              }"
              class="nav-link actives"
              data-test="menus-item-settings"
            >
              <i class="fas fa-cog" /><span>{{ $t("Settings") }}</span>
            </router-link>
          </li>
          <!-- <li class="nav-item nav-item-submenu">
            <span class="nav-link cursor-pointer">
              <i class="fas fa-cog" /><span>{{ $t("Settings") }}</span>
            </span>
            <ul class="nav nav-group-sub">
              <template v-for="(item, key) in menuSetting">
                <li
                  v-if="checkFeature(item.visible)"
                  :key="key"
                  class="nav-item"
                  style="cursor: pointer;"
                >
                  <router-link
                    :to="{name: item.path}"
                    class="nav-link"
                  >
                    <i :class="[item.icon]" />
                    {{ $t(item.name) }}
                  </router-link>
                </li>
              </template>
            </ul>
          </li> -->
          <!-- /page kits -->
        </ul>
      </div>
      <!-- /main navigation -->
    </div>
    <!-- /sidebar content -->
  </div>
<!-- /main sidebar -->
</template>

<script>
import Cookies from "js-cookie";
import Api from "@/services/endpoint/tenant.service.js";
import { localRead } from "@/store/lang";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import moment from "moment";

export default {
  name: "LeftMenu",
  data() {
    return {
      // leftMenu: JSON.parse(Cookies.get("menus")),
      // wmsSevice: JSON.parse(Cookies.get("WmsSevice")),
      // marketPlaceExpire: JSON.parse(Cookies.get('tenant')).need_upgrade_integration,

      leftMenu: {},
      wmsSevice: {},
      marketPlaceExpire: false,
      gochatLoading: false,
      planEndsAt : 8,
      menuSetting: [
        {
          name: 'General',
          icon: 'fa fa-cogs',
          path: 't.a.settings.general',
          visible: null
        },
        {
          name: 'Payment & Shipping',
          icon: 'fa fa-university',
          path: 't.a.settings.ecommerce-finance',
          visible: null
        },
        {
          name: 'Buying & Selling',
          icon: 'fa-solid fa-cart-shopping',
          path: 't.a.settings.buying-selling',
          visible: null
        },
        {
          name: 'Notifications',
          icon: 'fa-solid fa-bell-on',
          path: 't.a.settings.notifications',
          visible: null
        },
        {
          name: 'Message Template',
          icon: 'fa-solid fa-message-lines',
          path: 't.a.settings.messagetemplate',
          visible: 'feature-message-template'
        },
        {
          name: 'Document',
          icon: 'fa fa-file-alt',
          path: 't.a.settings.document',
          visible: null
        },
        {
          name: 'CRM',
          icon: 'fa-solid fa-user-headset',
          path: 't.a.settings.crm',
          visible:
            // ถ้ามี features ดังต่อไปนี้จะซ่อน menu โดยไม่สนใจ feature crm
            [
              'feature-erp-oracle'
            ].some(slug => this.$store.state.user.feature.includes(slug)) ? 'none'
            // ต้องมี feature crm ถึงจะ แสดง menu
            : 'app-marketing-crm',
        },
      ]
    };
  },
  async mounted() {
    $("ul[data-nav-type^=accordion] li[class=nav-item]")
      .children(".nav-link")
      .on("click", function () {
        if ($(this).closest("ul").attr("class") == "nav nav-sidebar") {
          $("ul[data-nav-type^=accordion] .nav-item-submenu").removeClass(
            "nav-item-open"
          );
          $("ul[data-nav-type^=accordion] .nav-item-submenu > .nav-link")
            .next(".nav-group-sub")
            .attr("style", "display:none;");
        }
      });

      try {
        this.leftMenu = JSON.parse(Cookies.get("menus"));
        this.wmsSevice = JSON.parse(Cookies.get("WmsSevice"))
        this.marketPlaceExpire = JSON.parse(Cookies.get('tenant')).need_upgrade_integration
      }
      catch(err) {
        console.log('LeftMenu', err)
      }
  },
  methods: {
    menuValid(gropName) {
      return JSON.parse(Cookies.get("menus")).includes(gropName);
    },
    gotoGoChat() {

      let showExceed = this.$store.state.user.showExceed;

      if (showExceed.length > 0) {
        $("#alert-exceedlimit").modal('show');
        this.$parent.isShowPagemodal = false;
      }else{
          this.actionGotoChat();
      }
    },
    async actionGotoChat(){
      let queryString = `?language=${localRead("local").toUpperCase() == "TH" ? "THAI" : "ENGLISH"}`
      this.gochatLoading = true;
      try {
        const res = await Api.Integration.autoLoginSocial(queryString);
        if (res.data.success) {
          window.open(res.data.data.url);
          this.gochatLoading = false;
        }
        else {
          this.$toastr.e(this.$t(res.data.message),
            "<i class='fas fa-times-circle mr-2'></i>" + this.$t("Error")
          );
          this.gochatLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.gochatLoading = false;
      }
    },
    getProductLink(){
      let toDay = new Date();
      let startDate = moment(convertTimezone.utcToLocal(toDay));
      let endDate = moment(convertTimezone.utcToLocal(this.$store.state.user.getPlanActive.planEndsAt));
      let duration = moment.duration(endDate.diff(startDate));
      let daysEnds = duration.asDays();
      this.planEndsAt = Math.round(daysEnds);
    },

    checkFeature(feature){
      if(feature != null){
        return JSON.parse(Cookies.get("features")).includes(feature) ? true : false;
      }
      return true;
    }
  },
  watch: {
    "$store.state.order.showModalAfterChat"(nval, oval) {
      if(nval){
        this.actionGotoChat();
      }
    },
    "$store.state.user.getPlanActive.planEndsAt"(nval, oval) {
      if(nval){
        this.getProductLink();
      }
    },
    "$store.state.user.setMenuWms"(nval, oval) {
      console.log('WmsSevice',Cookies.get("WmsSevice"));
      this.wmsSevice = Cookies.get("WmsSevice");
    },
  },
};
</script>
<style scoped>
.actives.router-link-active {
  background: #1f88e5;
}
.span-beta{
    background-color: #F44336 !important;
    height:1.3rem;
    margin-top: 2px !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/LeftMenu.vue